var _style, _circle, _circle2, _circle3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185.61,
    height: 185.61,
    viewBox: "0 0 185.61 185.61"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#012846}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    transform: "rotate(-45 92.8 92.8)",
    cx: 92.8,
    cy: 92.8,
    fill: "#ef3e31",
    r: 92.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 55.24,
    cy: 84.83,
    r: 8.79
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 130.36,
    cy: 84.83,
    r: 8.79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.22 144.41c-.76 0-1.53-.24-2.19-.74L80.19 127.9a3.62 3.62 0 114.38-5.78l20.84 15.77a3.62 3.62 0 01-2.19 6.52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.39 144.41a3.63 3.63 0 01-2.2-6.52l20.84-15.77a3.63 3.63 0 014.38 5.78l-20.84 15.77c-.65.5-1.42.74-2.18.74z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxODUuNjEiIGhlaWdodD0iMTg1LjYxIiB2aWV3Qm94PSIwIDAgMTg1LjYxIDE4NS42MSI+PHN0eWxlPi5zdDF7ZmlsbDojMDEyODQ2fTwvc3R5bGU+PGNpcmNsZSB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgOTIuOCA5Mi44KSIgY3g9IjkyLjgiIGN5PSI5Mi44IiBmaWxsPSIjZWYzZTMxIiByPSI5Mi44Ii8+PGNpcmNsZSBjbGFzcz0ic3QxIiBjeD0iNTUuMjQiIGN5PSI4NC44MyIgcj0iOC43OSIvPjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjEzMC4zNiIgY3k9Ijg0LjgzIiByPSI4Ljc5Ii8+PHBhdGggY2xhc3M9InN0MSIgZD0iTTEwMy4yMiAxNDQuNDFjLS43NiAwLTEuNTMtLjI0LTIuMTktLjc0TDgwLjE5IDEyNy45YTMuNjIgMy42MiAwIDExNC4zOC01Ljc4bDIwLjg0IDE1Ljc3YTMuNjIgMy42MiAwIDAxLTIuMTkgNi41MnoiLz48cGF0aCBjbGFzcz0ic3QxIiBkPSJNODIuMzkgMTQ0LjQxYTMuNjMgMy42MyAwIDAxLTIuMi02LjUybDIwLjg0LTE1Ljc3YTMuNjMgMy42MyAwIDAxNC4zOCA1Ljc4bC0yMC44NCAxNS43N2MtLjY1LjUtMS40Mi43NC0yLjE4Ljc0eiIvPjwvc3ZnPg==";
export { SvgNote4 as ReactComponent };